import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    .fill{
       min-width: 4rem;
    }

    .refresh{
        position: absolute;
        top: 16px;
        right: 10px;
        font-size: 1.4rem;
        color: #7A05A7;

        @media (min-width: 960px){
            cursor: pointer;
        }

        @media (max-width: 320px){
            top: 0.8rem;
            right: 0.8rem;
            font-size: 1.2rem;
        }
    }
  
    .moreOptions{
        position: absolute;
        top: 16px;
        right: 10px;
        font-size: 1.5rem;
        color: #7A05A7;

        @media (min-width: 960px){
            cursor: pointer;
        }
    }

`

export const BusinessGraphicsAndDatas = styled.div`
    width: 100%;
`